module.exports = __webpack_public_path__ + "img/7.11e8a9d6.jpg";